import { FunctionComponent } from 'react';
import { default as ReactDropzone, DropzoneProps } from 'react-dropzone';
import { Box, Typography } from '@mui/material';

export const Dropzone: FunctionComponent<
    React.PropsWithChildren<DropzoneProps>
> = (dropzoneProps) => {
    return (
        <ReactDropzone {...dropzoneProps}>
            {({ getRootProps, getInputProps }) => {
                const { ...rootProps } = getRootProps();

                return (
                    <>
                        <Box
                            {...rootProps}
                            sx={(theme) => ({
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                border: `1px dashed`,
                                borderColor: 'divider',
                                width: '100%',
                                height: '100%',
                                borderRadius: 2.5,
                                transition: theme.transitions.create(
                                    ['background-color'],
                                    {
                                        duration:
                                            theme.transitions.duration.standard,
                                    }
                                ),

                                '&:hover': {
                                    backgroundColor: 'divider',
                                },
                            })}
                        >
                            <input {...getInputProps()} />
                            <Typography>
                                Datei reinziehen oder hier klicken
                            </Typography>
                        </Box>
                    </>
                );
            }}
        </ReactDropzone>
    );
};
